<template>
  <div class="boxInfo1">
    <el-tabs type="border-card" value="first" @tab-click="handleClick">
      <!--'新增报价'\'报价详情'-->
      <el-tab-pane :label="tabTitle" name="first">
        <Details
          :edit-data="editData" :operation-type="operationType" :copy-model="copyModel"
          @saveData="saveChange"
        />
      </el-tab-pane>
      <!--操作日志-->
      <el-tab-pane v-if="isShowLog" :label="$t('basicData.OperationalLogs')" name="second">
        <operationLog v-if="isSecondActive" :edit-data="editData" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: 'DetailLog',
  components: {
    Details: () => import('./DetailsCmp'),
    operationLog: () => import('./operationLog')
  },
  props: {
    // 类型标识 1新增 2查看 3 编辑
    operationType: {
      type: Number,
      default: 1
    },
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 复制模型
    copyModel: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      isSecondActive: false
    };
  },
  computed: {
    // 是否显示日志
    isShowLog() {
      const operationType = this.operationType;
      // 新增 复制 的时候不显示
      return !(operationType === 1 || operationType === 4);
    },

    // tab title
    tabTitle() {
      const operationType = this.operationType;

      if (operationType === 1 || operationType === 4) {
        return this.$t('basicData.AddANewQuote');
      }

      return this.$t('basicData.QuoteDetails');
    }
  },

  methods: {
    saveChange(data) {
      this.$emit('saveChange', data);
    },
    handleClick(tab) {
      this.isSecondActive = tab.name === 'second' && !this.isSecondActive;
    }
  }
};
</script>

<style>
.boxInfo1 .el-tabs__content{
  padding: 0;
}
</style>
